// Mock data for Big Dick's Undergear website

export const brand = {
  name: "BIG DICK'S",
  sub: "UNDERGEAR",
  tagline: "CONFIDENCE STARTS UNDERNEATH",
  logoUrl: "https://customer-assets-m6fa6gv7.emergentagent.net/job_create-from-pic/artifacts/7cw9fvsh_new%20logo.png",
  shippingBanner: "FREE SHIPPING ON ORDERS OVER $75",
};

// Individual product images per color
export const productImages = {
  black: "https://customer-assets-m6fa6gv7.emergentagent.net/job_create-from-pic/artifacts/pnj0a186_black.png",
  charcoal: "https://customer-assets-m6fa6gv7.emergentagent.net/job_create-from-pic/artifacts/bh74nzbi_gray.png",
  navy: "https://customer-assets-m6fa6gv7.emergentagent.net/job_create-from-pic/artifacts/f6r4tb8h_blue.png",
  burgundy: "https://customer-assets-m6fa6gv7.emergentagent.net/job_create-from-pic/artifacts/c5gl1lot_red.png",
};

// Deprecated composite sheet (kept for compatibility)
export const productSheetUrl = productImages.black;

export const navigation = [
  { label: "SHOP", href: "#shop" },
  { label: "COLLECTIONS", href: "#collections" },
  { label: "ABOUT US", href: "#about" },
  { label: "SIZING", href: "#sizing" },
  { label: "REVIEWS", href: "#reviews" },
];

export const heroImages = {
  main: "https://images.unsplash.com/photo-1614396648745-d5de9c9e037e?auto=format&fit=crop&w=1400&q=80",
  lifestyle: "https://images.unsplash.com/photo-1754473698816-767ee4b62466?auto=format&fit=crop&w=1200&q=80",
  detail: "https://images.unsplash.com/photo-1598735064309-86f7f4ba875b?auto=format&fit=crop&w=1200&q=80",
  torso: "https://images.unsplash.com/photo-1608881577736-b56ef031d349?auto=format&fit=crop&w=1400&q=80",
};

export const products = [
  {
    id: "bd-black",
    slug: "bd-signature-boxer-brief-black",
    name: "BD Signature Boxer Brief",
    color: "BLACK",
    swatch: "#0a0a0a",
    img: productImages.black,
    price: 24,
    compareAt: null,
    sale: false,
    tag: "BESTSELLER",
    accent: "#e11d1d",
  },
  {
    id: "bd-charcoal",
    slug: "bd-signature-boxer-brief-charcoal",
    name: "BD Signature Boxer Brief",
    color: "CHARCOAL",
    swatch: "#2b2b2e",
    img: productImages.charcoal,
    price: 24,
    compareAt: null,
    sale: false,
    tag: null,
    accent: "#e11d1d",
  },
  {
    id: "bd-navy",
    slug: "bd-signature-boxer-brief-navy",
    name: "BD Signature Boxer Brief",
    color: "NAVY",
    swatch: "#0f1a30",
    img: productImages.navy,
    price: 24,
    compareAt: null,
    sale: false,
    tag: null,
    accent: "#e11d1d",
  },
  {
    id: "bd-burgundy",
    slug: "bd-signature-boxer-brief-burgundy",
    name: "BD Signature Boxer Brief",
    color: "BURGUNDY",
    swatch: "#4a0f18",
    img: productImages.burgundy,
    price: 19,
    compareAt: 24,
    sale: true,
    tag: "SALE",
    accent: "#ffffff",
  },
];

// Deep product info used by the /products/:id page
export const productDetails = {
  description:
    "Meet the BD Signature Boxer Brief — engineered for men who know. A premium 95% cotton / 5% spandex blend delivers a soft hand and 4-way stretch, while our signature jacquard waistband holds its place all day. The embroidered BD leg logo is our promise: confidence starts underneath.",
  bullets: [
    "95% combed cotton / 5% spandex jersey",
    'Signature 1.75" jacquard waistband — no roll, no pinch',
    "Contoured pouch with ergonomic support",
    "Flatlock seams for zero chafe",
    "Tagless print label for total comfort",
    "Machine wash cold, tumble dry low",
  ],
  sizes: ["S", "M", "L", "XL", "XXL"],
  gallery: [
    productImages.black,
    productImages.charcoal,
    productImages.navy,
    productImages.burgundy,
  ],
  shipping: {
    ships: "Ships in 1–2 business days",
    returns: "30-day easy returns",
    packaging: "Discreet, unbranded packaging",
  },
};

export const productFeatures = [
  { icon: "HeartPulse", label: "PREMIUM\nCOTTON BLEND" },
  { icon: "Move", label: "4-WAY\nSTRETCH" },
  { icon: "Wind", label: "BREATHABLE\nCOMFORT" },
  { icon: "Waves", label: "NO-ROLL\nWAISTBAND" },
  { icon: "Tag", label: "TAGLESS\nCOMFORT" },
];

export const trustBadges = [
  { icon: "Award", title: "PREMIUM QUALITY", sub: "Made to last." },
  { icon: "Ruler", title: "PERFECT FIT", sub: "Designed for movement." },
  { icon: "Sun", title: "ALL DAY COMFORT", sub: "Feel good all day." },
  { icon: "ShieldCheck", title: "SATISFACTION GUARANTEED", sub: "Love it or your money back." },
];

export const difference = [
  {
    title: "BUILT FOR COMFORT",
    body: "Soft, breathable cotton with the perfect amount of stretch.",
  },
  {
    title: "MADE TO MOVE",
    body: "Ergonomic design that moves with you, not against you.",
  },
  {
    title: "STAY-PUT WAISTBAND",
    body: "No roll, no pinch, just all-day comfort.",
  },
  {
    title: "CONFIDENCE GUARANTEED",
    body: "Because when you feel good underneath, it shows everywhere.",
  },
];

export const collections = [
  { name: "THE ESSENTIALS", copy: "Everyday staples in signature black.", image: "https://images.unsplash.com/photo-1614396648745-d5de9c9e037e?auto=format&fit=crop&w=900&q=80" },
  { name: "THE BOLD", copy: "Rich burgundy and deep navy for the fearless.", image: "https://images.unsplash.com/photo-1598735064309-86f7f4ba875b?auto=format&fit=crop&w=900&q=80" },
  { name: "THE BUNDLE", copy: "Save 20% when you stock the drawer.", image: "https://images.unsplash.com/photo-1608881577736-b56ef031d349?auto=format&fit=crop&w=900&q=80" },
];

export const reviews = [
  {
    name: "Marcus T.",
    location: "Austin, TX",
    rating: 5,
    title: "Finally, underwear that fits.",
    body: "I've tried every brand. Nothing rides up. Nothing rolls. These are the real deal.",
  },
  {
    name: "Derek W.",
    location: "Denver, CO",
    rating: 5,
    title: "Confidence in a box.",
    body: "The waistband stays put through the gym, the office, everywhere. Buying more in every color.",
  },
  {
    name: "Jonathan R.",
    location: "Brooklyn, NY",
    rating: 5,
    title: "Discreet packaging, elite product.",
    body: "Showed up in a plain box. Opened it up and immediately upgraded my whole drawer.",
  },
  {
    name: "Sam K.",
    location: "Los Angeles, CA",
    rating: 5,
    title: "Worth every dollar.",
    body: "The cotton blend is soft but never loses shape after washing. Instant wardrobe staple.",
  },
];

export const sizingChart = [
  { size: "S", waist: "28-30\"", hip: "34-36\"" },
  { size: "M", waist: "31-33\"", hip: "37-39\"" },
  { size: "L", waist: "34-36\"", hip: "40-42\"" },
  { size: "XL", waist: "37-39\"", hip: "43-45\"" },
  { size: "XXL", waist: "40-42\"", hip: "46-48\"" },
];

export const footerLinks = {
  Shop: ["All Products", "Boxer Briefs", "Bundles", "New Arrivals", "Gift Cards"],
  Support: ["Contact Us", "Shipping", "Returns", "Sizing Guide", "FAQ"],
  Company: ["About", "The Club", "Reviews", "Wholesale", "Careers"],
};

export const footerBadges = [
  { icon: "Mail", title: "DISCREET PACKAGING", sub: "No one will know." },
  { icon: "RefreshCw", title: "EASY RETURNS", sub: "No hassle returns." },
  { icon: "ShoppingBag", title: "SECURE CHECKOUT", sub: "Shop with confidence." },
];
